<template>
  <div class="agents">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <div class="page-title">Agent</div>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">Agent</li>
                </ul>
              </div>
              <div class="col-auto float-end ms-auto">
                <a
                  href="javascript:void(0)"
                  class="btn add-btn"
                  data-toggle="modal"
                  data-target="#add_form"
                  @click="showBroadcast(true)"
                >
                  <i class="fa fa-plus"></i> Add Agent
                </a>
                <a
                  v-show="false"
                  ref="formBcEdit"
                  class="btn add-btn"
                  @click="showBroadcast(false)"
                  href="#"
                  data-toggle="modal"
                  data-target="#add_form"
                >
                  <i class="fa fa-tags"></i> Edit Agent
                </a>
                <a
                  v-show="false"
                  ref="formBcEditP"
                  class="btn add-btn"
                  @click="showBroadcastP()"
                  href="#"
                  data-toggle="modal"
                  data-target="#password_form"
                >
                  <i class="fa fa-tags"></i> Edit Password
                </a>
              </div>
            </div>
          </div>
          <!-- Page Header -->

          <!-- Search Filter -->
          <div class="row filter-row">
            <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus">
                <input
                  v-model="serverParams.email"
                  type="text"
                  class="form-control floating"
                />
                <label class="focus-label">Email</label>
              </div>
            </div>
            <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus">
                <input
                  v-model="serverParams.name"
                  type="text"
                  class="form-control floating"
                />
                <label class="focus-label">Name</label>
              </div>
            </div>
            <div class="col-sm-6 col-md-3">
              <a
                href="javascript:void(0)"
                class="btn btn-success btn-block"
                @click.prevent="searchData"
              >
                Search
              </a>
            </div>
          </div>
          <!-- Search Filter -->

          <div class="row agent-grid-row">
            <template v-if="loading">
              <div class="col-md-12">
                <skeleton :count="1" />
              </div>
            </template>
            <template v-if="rows.length">
              <div
                v-for="(row, index) in rows"
                :key="index"
                class="col-md-4 col-sm-6 col-12 col-lg-4 col-xl-3"
              >
                <div class="profile-widget">
                  <div class="dropdown profile-action">
                    <a
                      href="#"
                      class="action-icon dropdown-toggle"
                      data-toggle="dropdown"
                      aria-expanded="false"
                      ><i class="material-icons">more_vert</i></a
                    >
                    <div class="dropdown-menu dropdown-menu-right">
                      <a
                        class="dropdown-item"
                        @click.prevent="detailData(row.id)"
                        ><i class="fa fa-pencil m-r-5"></i> Profile</a
                      >
                      <a
                        class="dropdown-item"
                        @click.prevent="detailDataP(row.id)"
                        ><i class="fa fa-key m-r-5"></i> Set Password</a
                      >
                    </div>
                  </div>
                  <h4 class="user-name m-t-10 mb-0 text-ellipsis">
                    {{ row.first_name }} {{ row.last_name }}
                  </h4>
                  <h5 class="user-name m-t-10 mb-0 text-ellipsis">
                    {{ row.email }}
                  </h5>
                  <router-link
                    :to="`/client/agents/roles?id=${row.id}`"
                    class="btn btn-white btn-sm m-t-10"
                  >
                    Roles
                  </router-link>
                </div>
              </div>
            </template>
            <template v-else-if="rows.length < 1 && !loading">
              <div class="col-md-12 text-center">-empty-</div>
            </template>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-6">
              <span class="footer__row-count__label">Displaying</span>
              <select
                @change="onPerPageChange(serverParams.perPage)"
                autocomplete="off"
                name="perPageSelect"
                v-model="serverParams.perPage"
                style="width: 100px"
                class="select-to-paginasi"
              >
                <option value="10">10 / page</option>
                <option value="20">20 / page</option>
                <option value="30">30 / page</option>
                <option value="40">40 / page</option>
                <option value="50">50 / page</option>
              </select>
              <span class="footer__row-count__label"
                >of {{ totalRecords }} total records</span
              >
            </div>
            <div class="col-sm-12 col-md-6 text-right">
              <a
                href="javascript:void(0)"
                @click="onPrevChange(parseInt(currentPage))"
                tabindex="0"
                class="btn"
                :class="{ disabled: parseInt(currentPage) - 1 <= 0 }"
              >
                <span class="chevron left"></span>
                <span>Prev</span>
              </a>
              page
              <input
                style="width: 100px"
                min="1"
                type="number"
                v-model="currentPage"
                @keyup.enter="onPageChange(parseInt(currentPage))"
                class
              />
              of {{ Math.ceil(totalRecords / serverParams.perPage) }}
              <a
                href="javascript:void(0)"
                @click="onNextChange(parseInt(currentPage))"
                tabindex="0"
                class="footer__navigation__page-btn"
                :class="
                  'btn ' +
                    {
                      disabled:
                        parseInt(currentPage) + 1 >
                        Math.ceil(totalRecords / serverParams.perPage)
                    }
                "
              >
                <span>Next</span>
                <span class="chevron right"></span>
              </a>
            </div>
          </div>
        </div>
        <!-- Page Content -->
      </div>
      <!-- Page Wrapper -->
    </div>

    <form-data :searchData="searchData" />
    <form-password :searchData="searchData" />
  </div>
</template>

<script>
import { Skeleton } from "vue-loading-skeleton";
import FormData from "./form.vue";
import FormPassword from "./password.vue";

import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Skeleton,
    FormData,
    FormPassword
  },
  data() {
    return {
      isLoading: false,
      loading: false,
      rows: [],
      totalRecords: 0,
      currentPage: 1,
      rowPage: 1,
      serverParams: {
        name: "",
        description: "",
        page: 1,
        perPage: 20 // perPage
      }
    };
    //  isactive : true
  },
  watch: {},
  created() {
    this.loadItems();
    this.currentPage = this.serverParams.page;
  },
  methods: {
    async detailData(id) {
      //set false dulu
      this.$store.dispatch("agent/setIsShowForm", false);

      let formData = await {
        id: "",
        email: "",
        first_name: "",
        last_name: ""
      };
      await this.$store
        .dispatch("agent/getAgentList", { id }) // sesuai kan dengan method di API
        .then(response => {
          var { data } = response;
          formData.email = data.data[0].email;
          formData.first_name = data.data[0].first_name;
          formData.last_name = data.data[0].last_name;
        });
      // console.log(formData);
      formData.id = id;
      await this.$store.dispatch("agent/actFormParamSt", formData);
      // this.showBroadcast();
      var elem = this.$refs.formBcEdit;
      elem.click();
    },
    async detailDataP(id) {
      //set false dulu
      this.$store.dispatch("agent/setIsShowFormP", false);

      let formData = await {
        id: "",
        email: "",
        new_password: ""
      };
      await this.$store
        .dispatch("agent/getAgentList", { id }) // sesuai kan dengan method di API
        .then(response => {
          var { data } = response;
          formData.email = data.data[0].email;
        });
      // console.log(formData);
      formData.id = id;
      await this.$store.dispatch("agent/actFormParamStP", formData);
      // this.showBroadcast();
      var elem = this.$refs.formBcEditP;
      elem.click();
    },
    showBroadcast(newData) {
      if (typeof newData != "undefined" && newData == true) {
        this.$store.dispatch("agent/setIsShowForm", false);

        let formData = {
          id: "",
          email: "",
          first_name: "",
          last_name: ""
        };
        this.$store.dispatch("agent/actFormParamSt", formData);
      }
      var that = this;
      setTimeout(function() {
        var liContainer = document.getElementById("add_form");
        var isShowModal = liContainer.classList.contains("show");
        // console.log("isShowModal", isShowModal);
        // this.$root.$emit("infiniteHandlerContact");
        if (isShowModal == true) {
          that.$store.dispatch("agent/setIsShowForm", true);
        }
      }, 1000);
    },
    showBroadcastP(newData) {
      var that = this;
      setTimeout(function() {
        var liContainer = document.getElementById("password_form");
        var isShowModal = liContainer.classList.contains("show");
        // console.log("isShowModal", isShowModal);
        // this.$root.$emit("infiniteHandlerContact");
        if (isShowModal == true) {
          that.$store.dispatch("agent/setIsShowFormP", true);
        }
      }, 1000);
    },
    updateParams(newProps) {
      // console.log("newprops", newProps);
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    async onPageChange(page) {
      await this.updateParams({ page: page });
      this.currentPage = page;
      await this.loadItems();
    },
    async onNextChange(page) {
      if (
        page + 1 <=
        Math.ceil(this.totalRecords / this.serverParams.perPage)
      ) {
        await this.updateParams({ page: page + 1 });
        this.currentPage = page + 1;
        await this.loadItems();
      }
    },
    async onPrevChange(page) {
      // console.log("this.currentPage:: ", this.currentPage);
      if (this.currentPage == 1) {
        return;
      }
      if (
        page - 1 <=
        Math.ceil(this.totalRecords / this.serverParams.perPage)
      ) {
        await this.updateParams({ page: page - 1 });
        this.currentPage = page - 1;
        await this.loadItems();
      }
    },
    async onPerPageChange(params) {
      await this.updateParams({
        page: this.currentPage,
        perPage: this.serverParams.perPage
      });
      await this.loadItems();
    },

    async searchData() {
      // this.currentPage = await 1;
      // this.serverParams.columnFilters.page = await 1;
      // await this.getListData();

      this.currentPage = 1;
      this.rows = await [];
      this.loading = await true;
      this.totalRecords = await 0;
      var params = await { page: this.currentPage };
      await this.updateParams(params);
      await this.loadItems();
      this.loading = await false;
    },
    async loadItems() {
      this.loading = await true;
      this.serverParams.page =
        this.serverParams.page - 1 <= 0
          ? await 0
          : await ((this.serverParams.page - 1) * this.serverParams.perPage);

      await this.$store
        .dispatch("agent/getAgentList", this.serverParams) // sesuai kan dengan method di API
        .then(response => {
          const { data } = response;
          this.totalRecords = data.totalRecords;
          this.rowPage = data.page;
          this.rows = data.data;
          // console.log("rows", this.rows);
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  mounted() {
    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }

    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%"
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }

    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "agent-list"
};
</script>



// WEBPACK FOOTER //
// src/views/monitoring/agents/list.vue